import React from 'react';

const CloseIcon = () => (
  <svg
    width='10'
    height='11'
    viewBox='0 0 10 11'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M9.71618 9.2213C9.84828 9.35339 9.92248 9.53254 9.92248 9.71935C9.92248 9.90615 9.84828 10.0853 9.71618 10.2174C9.58409 10.3495 9.40494 10.4237 9.21814 10.4237C9.03133 10.4237 8.85218 10.3495 8.72009 10.2174L4.99997 6.49611L1.27869 10.2162C1.1466 10.3483 0.967442 10.4225 0.780639 10.4225C0.593835 10.4225 0.414682 10.3483 0.282592 10.2162C0.150502 10.0841 0.0762939 9.90498 0.0762939 9.71818C0.0762939 9.53137 0.150502 9.35222 0.282592 9.22013L4.00388 5.50001L0.283763 1.77872C0.151673 1.64663 0.0774658 1.46748 0.0774658 1.28068C0.0774658 1.09387 0.151673 0.914719 0.283763 0.782628C0.415854 0.650538 0.595007 0.57633 0.78181 0.57633C0.968614 0.57633 1.14777 0.650538 1.27986 0.782628L4.99997 4.50392L8.72126 0.782042C8.85335 0.649952 9.03251 0.575745 9.21931 0.575745C9.40611 0.575745 9.58527 0.649952 9.71736 0.782042C9.84945 0.914133 9.92365 1.09329 9.92365 1.28009C9.92365 1.46689 9.84945 1.64605 9.71736 1.77814L5.99607 5.50001L9.71618 9.2213Z'
      fill='white'
    />
  </svg>
);

export default CloseIcon;
